import { API_ADMIN_URL } from "../../../config/constants";
import { postRequest } from "../../API";

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/general-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Afsar Ali
* Date          : 10-01-2026 
*********************************************************/
export const addeditdata = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/general-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : sentAnalyserEmail
* Description   : sent analyser email
* By            : Afsar Ali
* Date          : 10-01-2026 
*********************************************************/
export const sentAnalyserEmail = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/analyser-email`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : getBas264Image
* Description   : Get base64 image from url
*********************************************************/
export const getBas264Image = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/proxy-image`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return res?.data?.response?.image;
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
